import React, { useState } from "react";
import {
  View,
  StyleSheet,
  TextInput,
  Keyboard,
  ToastAndroid,
} from "react-native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import UploadProof from "./components/UploadProof";
import Button from "@components/Button";
import MainTransactionCard from "./components/MainTransactionCard";
import color from "@constants/color";
import metrics from "@constants/metrics";
import { raiseDispute } from "@services/api";
import Text from "@components/CustomText";

const PATH = "screens/Wallet/v2/CreateDispute";

interface CreateDisputeProps {
  navigation: any;
  route: any;
}

const CreateDispute: React.FC<CreateDisputeProps> = ({ navigation, route }) => {
  const txnData = route?.params?.data || {};
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [attachments, setAttachments] = useState([]);

  const onImgUpload = (imgs: any) => setAttachments(imgs);

  const submitDispute = async () => {
    try {
      setSubmitting(true);
      console.log({ description, attachments, txn_id: txnData?.id });
      if (description && attachments && txnData?.id) {
        const res = await raiseDispute({
          description,
          attachments,
          txn_id: txnData.id,
        });
        if (res?.data?.msg === "DISPUTE_CREATED") {
          navigation.pop();
        }
      }
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
    }
  };

  return (
    <>
      <HeaderWithBackAndTitle
        route={route}
        navigation={navigation}
        headertitle={t(`${PATH}/wallet`)}
        subHeaderTitle={undefined}
        headerStyle={undefined}
        rightIcon={undefined}
        RightButton={undefined}
        goingBackHandler={undefined}
        IsRightIconDropDown={undefined}
      />

      <View style={styles.container}>
        <Text variant="subtitle_20" style={styles.disputeTitle}>
          {t(`${PATH}/title`)}
        </Text>
        <MainTransactionCard
          disableCta={true}
          item={txnData}
          onPress={() => {}}
        />

        <View style={styles.uploadProofContainer}>
          <Text variant="body_text_4" style={styles.proofLabel}>
            {t(`${PATH}/uploadProof`)}
          </Text>
          <UploadProof onSubmit={onImgUpload} />
        </View>

        <View style={styles.disputeReasonContainer}>
          <TextInput
            value={description}
            placeholder={t(`${PATH}/explainInBrief`)}
            multiline
            onBlur={Keyboard.dismiss}
            onSubmitEditing={Keyboard.dismiss}
            onChangeText={(v) => {
              if (v.length > 300) {
                ToastAndroid.showWithGravity(
                  t(`${PATH}/descriptionLimit`),
                  ToastAndroid.SHORT,
                  ToastAndroid.CENTER,
                );
              } else {
                setDescription(v);
              }
            }}
            style={styles.textInput}
          />
        </View>

        <Button
          isSubmitting={submitting}
          btnText={t(`${PATH}/submit`)}
          disabled={!description || !attachments.length}
          buttonColor={color.greenHaze}
          containerStyle={styles.buttonContainer}
          buttonWidth={metrics.screenWidth - 150}
          onPress={submitDispute}
          height={40}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#f9f9f9",
    flex: 1,
  },
  row: {
    flexDirection: "row",
    margin: 16,
  },
  disputeTitle: {
    marginHorizontal: 16,
    marginVertical: 12,
    lineHeight: 30,
  },
  uploadProofContainer: {
    margin: 16,
    marginVertical: 0,
  },
  proofLabel: {
    margin: 4,
    marginBottom: 8,
  },
  disputeReasonContainer: {
    margin: 16,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    backgroundColor: color.white,
  },
  textInput: {
    fontSize: 14,
    height: 100,
    textAlignVertical: "top",
  },
  buttonContainer: {
    alignItems: "center",
    marginTop: 16,
  },
});

export default CreateDispute;
